;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export const forbiddenCountries = [
  'DZ',
  'AS',
  'VI',
  'AF',
  'BB',
  'BS',
  'BY',
  'BW',
  'BI',
  'VU',
  'VE',
  'GH',
  'GN',
  'GW',
  'GI',
  'GU',
  'ER',
  'ZW',
  'IQ',
  'IR',
  'IS',
  'YE',
  'KY',
  'KH',
  'KE',
  'CO',
  'CG',
  'KR',
  'XK',
  'CI',
  'CU',
  'LA',
  'LR',
  'LY',
  'LB',
  'MU',
  'ML',
  'MM',
  'MN',
  'NA',
  'NP',
  'NE',
  'NI',
  'OM',
  'PK',
  'PW',
  'PA',
  'RU',
  'WS',
  'SY',
  'SO',
  'SD',
  'TT',
  'TN',
  'UG',
  'FJ',
  'CF',
  'ZA',
  'SS',
  'JM',
];
